import useGetRequestBody from "../../useGetRequestBody";
import {getAllLocationNames} from "../../../components/location/requests/location-requests";
import {useMemo} from "react";

import {SnackbarShowMessage} from "../../../context/snackbar-context";

export interface ILocationName {
  id: string;
  locationName: string;
}

/**
 * Returns a list of all currently logged-in user's locations with an empty string id and 'All' location name
 * @param showMessage - function to show messages from the api response, optional
 * @returns {ILocationName[]}
 */
const useAllLocationNames = (showMessage?: SnackbarShowMessage): ILocationName[] => {
  const allLocations: ILocationName[] = useGetRequestBody(getAllLocationNames, useMemo(() => [], []), showMessage);
  return useMemo(() => [{id: '', locationName: 'All'}, ...allLocations], [allLocations]);
};

export default useAllLocationNames;
